import React, { useState, useCallback, memo } from 'react'
import Box from '@/primitives/Box'
import FlexV2 from '@/primitives/FlexV2'
import Text from '@/primitives/Text'
import Button from '@/primitives/Button'
import { SectionHeader, AnimatedMessage } from './shared'
import { getPredefinedQuestions, getAnswers } from '../constants'
import Strings from '@/components/TrialModeView/Strings'

const AIChat = memo(() => {
  const [selectedQuestion, setSelectedQuestion] = useState(null)
  const [generating, setGenerating] = useState(false)
  const [answer, setAnswer] = useState('')
  const strings = Strings()

  const handleSelectQuestion = useCallback(id => {
    setSelectedQuestion(id)
    setGenerating(true)
    setAnswer('')

    setTimeout(() => {
      setGenerating(false)
      setAnswer(getAnswers()[id])
    }, 1500)
  }, [])

  return (
    <Box className='ai-chat'>
      <FlexV2 direction='column' axisGap={200}>
        <SectionHeader icon='forum' title={strings.askTheAssistant} />

        <Box className='questions-container'>
          <Text size={100} fontWeight={500}>
            {strings.selectQuestion}
          </Text>
          <FlexV2 direction='column' axisGap={100} className='question-list'>
            {getPredefinedQuestions().map(question => (
              <Button
                key={question.id}
                variant={
                  selectedQuestion === question.id ? 'primary' : 'outline'
                }
                onClick={() => handleSelectQuestion(question.id)}
                className='question-list-item'
              >
                {question.text}
              </Button>
            ))}
          </FlexV2>
        </Box>

        {generating && (
          <AnimatedMessage
            message={strings.analyzingTrialDataForAnswer}
            status='processing'
          />
        )}

        {answer && (
          <Box className='answer-container'>
            <Text size={100} fontWeight={500}>
              {strings.answer}
            </Text>
            <Box className='answer-content'>
              <Text>{answer}</Text>
            </Box>
          </Box>
        )}
      </FlexV2>
    </Box>
  )
})

export default AIChat
